import type { Action } from './Farm';
import { generateBedName } from '../utils/bedNameGenerator';

type EntitySummary = {
  id: number | string;
  name?: string | null;
};

export interface Bed {
  id: number | string;
  storeId?: string;
  plotId: number | string;
  name: string;
  length?: number | null;
  description?: string | null;
  area?: number | null;
  size_cm_encoded?: number | null;
  geo_location?: string | null;
  row_number?: number | null;
  position_number?: number | null;
  actions?: Action[];
  plotSummary?: EntitySummary;
  fieldSummary?: EntitySummary;
  farmSummary?: EntitySummary;
}

export const adaptBed = (data: any): Bed => ({
  id: data.id,
  storeId: data.storeId ?? data.store_id ?? undefined,
  plotId: data.plotId ?? data.plot_id ?? data.sectionId ?? data.section_id,
  name: data.name ?? (data.row_number !== undefined || data.position_number !== undefined
    ? generateBedName(data.row_number, data.position_number, data.id)
    : `BED-${data.id}`),
  length: data.length ?? null,
  description: data.description ?? null,
  area: data.area ?? null,
  size_cm_encoded: data.size_cm_encoded ?? null,
  geo_location: data.geo_location ?? null,
  row_number: data.row_number ?? null,
  position_number: data.position_number ?? null,
  actions: (data.actions || []).map((a: any) =>
    typeof a === 'string'
      ? { title: '', code: a }
      : { title: a.title, code: a.code, state: a.state },
  ),
  plotSummary: data.plot
    ? {
        id: data.plot.id,
        name: data.plot.name ?? null,
      }
    : data.plotSummary ?? (data.plot_id && data.plot_name
        ? { id: data.plot_id, name: data.plot_name }
        : undefined),
  fieldSummary: data.plot?.field
    ? {
        id: data.plot.field.id,
        name: data.plot.field.name ?? null,
      }
    : data.fieldSummary ?? (data.field
        ? { id: data.field.id, name: data.field.name ?? null }
        : data.field_id
        ? { id: data.field_id, name: data.field_name ?? null }
        : undefined),
  farmSummary: data.plot?.field?.farm
    ? {
        id: data.plot.field.farm.id,
        name: data.plot.field.farm.name ?? null,
      }
    : data.farmSummary ?? (data.farm
        ? { id: data.farm.id, name: data.farm.name ?? null }
        : data.farm_id
        ? { id: data.farm_id, name: data.farm_name ?? null }
        : undefined),
});
